// extracted by mini-css-extract-plugin
export var card = "_ss-0";
export var details = "_ss-1";